<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <a-input-search
        v-model:value="keyword"
        enter-button
        class="w300 mr15"
        placeholder="请输入清单名称关键字"
        @search="search"
      ></a-input-search>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>

    <a-table
      row-key="id"
      size="small"
      :bordered="true"
      :loading="loading"
      :data-source="data?.records"
      :columns="columns"
      :scroll="{ x: true }"
      :pagination="false"
      :row-selection="{
        selectedRowKeys: selectedIds,
        onChange: onSelectionChange,
        fixed: true,
      }"
    >
      <template #index="{ record, index }">{{ index + 1 }}</template>
    </a-table>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, PropType } from "vue";
import { BudgetService } from "@/views/work-manage/budget/budget.service";
import { QuantityRecord } from "@/views/work-manage/budget/budget.interface";
import { columns } from "./constant";

export default defineComponent({
  name: "MaterialTable",
  props: {
    projectId: { type: String, default: "" },

    value: { type: Array as PropType<QuantityRecord[]>, default: [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: QuantityRecord[];
      selectedList: any[];
      columns: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns,
    });

    const { data, loading, run } = BudgetService.useQuantityDetailApi();

    const search = async () => {
      await run({ projectId: props.projectId });
    };

    const onSelectionChange = (ids: string[], selectedRows: QuantityRecord[]) => {
      state.selectedIds = ids;
      state.selectedRows = selectedRows;
    };

    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "id"));
    };

    onMounted(async () => {
      await search();
    });

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.id);
        state.selectedIds = ids;
      },
      { immediate: true }
    );

    return {
      ...toRefs(state),
      loading,
      data,
      search,
      onSelectionChange,
      add,
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
